export default __webpack_public_path__ + "static/media/arrow_choose_us.6daacc13.svg";